import { SponsorPlacement } from 'api';

export const placementLabelByValue: Record<SponsorPlacement, string> = {
  publisherNetwork: 'Publisher Network',
  headlinerApp: 'Headliner App',
  youtubePromotion: 'YouTube',
};
